import ProfilePage from "@/views/ProfilePage/ProfilePage";
import UsersPage from "@/views/Administration/UsersPage/UsersPage";
import AdminTasksPage from "@/views/Administration/AdminTasksPage/AdminTasksPage";
import OperationsHomePage from "@/views/Operations/OperationsHomePage";
import OperationsVectorizingPage from "@/views/Operations/OperationsVectorizingPage";
import OperationsObjectAnalysisPage from "@/views/Operations/OperationsObjectAnalysisPage";
import KomunalneObvezePage from "@/views/Operations/KomunalneObveze/KomunalneObvezePage";
import RadniSastanciPage from '@/views/Operations/RadniSastanci/RadniSastanciPage'
import UserPage from "@/views/Administration/UsersPage/UserPage";
import ProjectPage from "@/views/Administration/ProjectsPage/ProjectPage";
import ProjectsPage from "@/views/Administration/ProjectsPage/ProjectsPage";
import QualityControlPage from "@/views/Operations/QualityControl/QualityControlPage";

//Types
import { RouteType } from "@/@types/common";

const privateRoutes: RouteType[] = [
  { path: "/profile", name: "Profile", component: ProfilePage},
	{ path: "/users", name: "Map", component: UsersPage },
  { path: "/user/:user_id", name: "Map", component: UserPage },
	{ path: "/tasks", name: "Admin Tasks", component:  AdminTasksPage},
  { path: "/vectorizing", name:"Operation: Vectorizing", component: OperationsVectorizingPage},
  { path: "/object-analysis", name:"Operation: Object Analysis", component: OperationsObjectAnalysisPage},
  { path: "/utility-liabilities", name:"Operation: Utility Liabilities", component: KomunalneObvezePage},
  { path: "/radni-sastanci", name: "Sastanci", component: RadniSastanciPage },
  { path: "/operations", name:"Operations", component: OperationsHomePage},
	{ path: "/", name: "Home", component: OperationsHomePage },
  { path: "/projects", name: "Projects", component: ProjectsPage },
  { path: "/projects/:project_id", name: "Projects single", component: ProjectPage },
  { path: "/quality-control", name: "Quality control", component: QualityControlPage },
];

export default privateRoutes
